import Navbar from '../Navbar'
import Footer from '../Footer'
import Portfolio from '../Portfolio'
import RfqSection from '../RfqSection'
import SEO from '../SEO'
import Hero from './Hero'
import HomeServices from './HomeServices'
import AboutSheet from './AboutSheet'
import { HOME_GALLERY_IMAGES, HOME_I18N } from '../../data/home-i18n'
import useHashScrollOnLoad from '../../hooks/useHashScrollOnLoad'
import { HOME_BY_LANG } from '../../lib/routes'
import './home.css'

/**
 * The home page for one locale. Copy lives in src/data/home-i18n.js.
 *
 * @param {{ lang?: 'tr' | 'en' | 'de' }} props
 */
export default function HomePage({ lang = 'tr' }) {
  const t = HOME_I18N[lang] ?? HOME_I18N.tr
  useHashScrollOnLoad()

  return (
    <>
      <SEO
        exactTitle={t.seo.title}
        description={t.seo.description}
        keywords={t.seo.keywords}
        lang={lang}
        url={HOME_BY_LANG[lang]}
      />
      <Navbar lang={lang} />

      {/* <html lang> follows the route (DocumentLang in Router.jsx); main repeats
          it so the prerendered snapshot is right even before that effect runs. */}
      <main lang={lang}>
        <Hero lang={lang} />
        <HomeServices lang={lang} copy={t.services} />
        <Portfolio
          images={HOME_GALLERY_IMAGES}
          lang={lang}
          title={t.gallery.title}
          description={t.gallery.description}
        />
        <AboutSheet copy={t.about} />
        <RfqSection
          lang={lang}
          title={t.contact.title}
          description={t.contact.description}
          subjectPrefix=""
          service="general"
          formLocation="home_contact"
        />
      </main>

      <Footer lang={lang} />
    </>
  )
}
